import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg
        viewBox="0 0 416 416"
        width="416"
        height="416"
        xmlns="http://www.w3.org/2000/svg"
      >
        <symbol id="a" viewBox="-207.491 -207.49 414.981 414.981">
          <path
            d="m198.491 0c0-109.624-88.866-198.49-198.491-198.49-109.623 0-198.49 88.866-198.49 198.49 0 109.623 88.867 198.491 198.49 198.491 109.625 0 198.491-88.868 198.491-198.491z"
            fill="url(#b)"
            stroke="#5d6aa5"
            strokeWidth="18"
          />
          <path
            d="m.543 190.26c50.3-.373 104.324-20.494 143.335-66.953-1.66-39.852-72.986-80.704-132.511-125.68-49.945-37.738-126.373-73.128-178.643-87.032-49.698 95.152-13.55 186.622 48.772 238.038 29.158 25.513 73.097 41.968 119.047 41.627z"
            fill="url(#c)"
          />
          <path
            d="m107.395-49.37c0-16.763-5.9-31.045-17.694-42.839-11.801-11.801-26.076-17.694-42.839-17.694h-72.175c-16.764 0-31.046 5.894-42.84 17.694-11.801 11.794-17.694 26.076-17.694 42.839v181.137c12.856 0 23.827-6.287 32.923-18.859 9.094-12.572 13.642-27.706 13.642-45.4v-116.878c0-9.312 4.656-13.969 13.97-13.969h72.175c9.312 0 13.969 4.656 13.969 13.969v55.412c0 9-4.656 13.656-13.969 13.97h-13.97c-18.007.626-33.221 5.326-45.633 14.107-12.42 8.774-18.626 19.594-18.626 32.457h78.229c16.763 0 31.038-5.901 42.839-17.694 11.794-11.801 17.694-26.076 17.694-42.84v-55.412z"
            fill="#757575"
          />
          <path
            d="m103.971-51.741c0-16.763-5.9-31.045-17.694-42.839-11.801-11.801-26.076-17.694-42.839-17.694h-72.175c-16.763 0-31.045 5.894-42.839 17.694-11.801 11.794-17.694 26.076-17.694 42.839v181.136c12.856 0 23.828-6.287 32.922-18.859s13.642-27.706 13.642-45.4v-116.877c0-9.313 4.656-13.969 13.969-13.969h72.175c9.312 0 13.969 4.656 13.969 13.969v55.412c0 9-4.656 13.656-13.969 13.969h-13.97c-18.007.625-33.221 5.326-45.633 14.107-12.419 8.774-18.625 19.594-18.625 32.457h78.229c16.763 0 31.038-5.901 42.839-17.694 11.794-11.801 17.694-26.076 17.694-42.839v-55.412z"
            fill="#fff"
          />
        </symbol>
        <linearGradient
          id="b"
          gradientUnits="userSpaceOnUse"
          x1="-113.8594"
          x2="113.8594"
          y1="162.6079"
          y2="-162.6081"
        >
          <stop offset="0" stopColor="#283274" />
          <stop offset=".7088" stopColor="#283375" />
          <stop offset=".967" stopColor="#273f88" />
        </linearGradient>
        <linearGradient
          id="c"
          gradientUnits="userSpaceOnUse"
          x1="-109.1797"
          x2="5.1006"
          y1="156.1684"
          y2="-7.0408"
        >
          <stop offset="0" stopColor="#bfc8e6" />
          <stop offset=".0772" stopColor="#b6bedd" />
          <stop offset=".2039" stopColor="#9fa4c9" />
          <stop offset=".3642" stopColor="#7f82ae" />
          <stop offset=".5519" stopColor="#585c92" />
          <stop offset=".7582" stopColor="#283375" />
        </linearGradient>
        <use
          xlinkHref="#a"
          width="414.981"
          height="414.981"
          transform="matrix(1 0 0 -1 208.5918 208.3076)"
          x="-207.491"
          y="-207.49"
        />
      </svg>
    </>
  ),
  'BigBlueButton',
  '0 0 416 416',
);
